import { runInThisContext } from 'vm';

export class Visited {
    id: number;
    name: string;
    intercomNumber: string;
    residenceIds: number[] = [];
    companyIds: number[] = [];

    constructor(id: number, name: string, intercomNumber: string, residenceId: number, companyId: number) {
        this.id = id;
        this.name = name;
        this.intercomNumber = intercomNumber;
        this.addRelatedUnit(residenceId, companyId);
    }

    addRelatedUnit(residenceId: number, companyId: number) {
        if (residenceId > 0)
            this.residenceIds.push(residenceId);
        if (companyId > 0)
            this.companyIds.push(companyId);
    }
}
